const seoActionTypes =  {    
    RETRIEVED_SEO_GENERAL_SETTINGS: "RETRIEVED_SEO_GENERAL_SETTINGS",
    UPDATED_SEO_GENERAL_SETTINGS: "UPDATED_SEO_GENERAL_SETTINGS",
    SEO_GENERAL_SETTINS_CLIENT_MODIFIED: "SEO_GENERAL_SETTINS_CLIENT_MODIFIED",
    RETRIEVED_SEO_REGEX_SETTINGS: "RETRIEVED_SEO_REGEX_SETTINGS",
    UPDATED_SEO_REGEX_SETTINGS: "UPDATED_SEO_REGEX_SETTINGS",
    SEO_REGEX_SETTINS_CLIENT_MODIFIED: "SEO_REGEX_SETTINS_CLIENT_MODIFIED",
    TESTED_SEO_PAGE_URL: "TESTED_SEO_PAGE_URL",
    TESTED_SEO_URL_REWRITING: "TESTED_SEO_URL_REWRITING",
    CLEARED_SEO_TEST_PAGE_URL_RESULTS: "CLEARED_SEO_TEST_PAGE_URL_RESULTS",
    CLEARED_SEO_TEST_URL_REWRITING_RESULTS: "CLEARED_SEO_TEST_URL_REWRITING_RESULTS",
    RETRIEVED_SEO_SITEMAP_SETTINGS: "RETRIEVED_SEO_SITEMAP_SETTINGS",
    UPDATED_SEO_SITEMAP_SETTINGS: "UPDATED_SEO_SITEMAP_SETTINGS",
    SEO_SITEMAP_SETTINS_CLIENT_MODIFIED: "SEO_SITEMAP_SETTINS_CLIENT_MODIFIED",
    CLEARED_SEO_SITEMAP_CACHE: "CLEARED_SEO_SITEMAP_CACHE",
    RETRIEVED_SEO_SITEMAP_PROVIDERS: "RETRIEVED_SEO_SITEMAP_PROVIDERS",
    UPDATED_SEO_SITEMAP_PROVIDER: "UPDATED_SEO_SITEMAP_PROVIDER",
    CREATED_SEO_SITEMAP_VERIFICATION: "CREATED_SEO_SITEMAP_VERIFICATION",
    RETRIEVED_SEO_EXTENSION_URL_PROVIDERS: "RETRIEVED_SEO_EXTENSION_URL_PROVIDERS",
    UPDATED_SEO_EXTENSION_URL_PROVIDER: "UPDATED_SEO_EXTENSION_URL_PROVIDER"
};
export default seoActionTypes;
